import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { AppContextProvider } from '../../../../Services/AppContext';
import { LoadingSize } from '../../../../Components/Loading';
import NavigationMenuSuffixes from './NavigationMenuSuffixes';

loadDOMComponent({
	selector: 'react-navigation-menu-suffix',
	callback: ({ container }: any) => {
		const data = JSON.parse(container.getAttribute('data'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider
						loadingSize={LoadingSize.SMALL}
						showLoading={false}>
						<NavigationMenuSuffixes data={data} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
